/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);

const contact = Vue.resource('messages{/id}');

export default contact;



// WEBPACK FOOTER //
// ./src/resources/contact.js